/**
 * Product Custom JavaScript
 * Handles all interactions for the custom product page
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initProductGallery();
    initVariantSwatches();
    initStickyElements();
    initLazyLoading();
  }

  /**
   * Product Gallery Management
   */
  function initProductGallery() {
    const gallery = document.querySelector('[data-media-gallery]');
    if (!gallery) return;

    const thumbnails = gallery.querySelectorAll('[data-thumbnail-trigger]');
    const mediaItems = gallery.querySelectorAll('.media-item');

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', function() {
        // Remove active from all
        thumbnails.forEach(t => t.classList.remove('active'));
        mediaItems.forEach(m => m.classList.remove('active'));

        // Add active to clicked
        this.classList.add('active');
        if (mediaItems[index]) {
          mediaItems[index].classList.add('active');
        }

        // Scroll to top of media on mobile
        if (window.innerWidth <= 990) {
          const mediaContainer = gallery.querySelector('.media-main-container');
          if (mediaContainer) {
            mediaContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });
    });

    // Keyboard navigation for thumbnails
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('keydown', function(e) {
        let targetIndex;
        
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          targetIndex = (index + 1) % thumbnails.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          targetIndex = (index - 1 + thumbnails.length) % thumbnails.length;
        }

        if (targetIndex !== undefined) {
          thumbnails[targetIndex].click();
          thumbnails[targetIndex].focus();
        }
      });
    });
  }

  /**
   * Enhanced Variant Swatches
   */
  function initVariantSwatches() {
    const colorSwatches = document.querySelectorAll('.color-swatch');
    
    colorSwatches.forEach(swatch => {
      // Add aria-label for accessibility
      const input = document.querySelector(`#${swatch.getAttribute('for')}`);
      if (input) {
        swatch.setAttribute('aria-label', `Select ${input.value}`);
      }

      // Add tooltip on hover
      swatch.addEventListener('mouseenter', function() {
        const value = input ? input.value : '';
        if (value) {
          showTooltip(this, value);
        }
      });

      swatch.addEventListener('mouseleave', function() {
        hideTooltip();
      });
    });
  }

  let tooltipTimeout;
  function showTooltip(element, text) {
    hideTooltip();
    
    const tooltip = document.createElement('div');
    tooltip.className = 'swatch-tooltip';
    tooltip.textContent = text;
    tooltip.style.cssText = `
      position: absolute;
      background: #000;
      color: white;
      padding: 6px 12px;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      z-index: 1000;
      pointer-events: none;
    `;
    
    document.body.appendChild(tooltip);
    
    const rect = element.getBoundingClientRect();
    tooltip.style.top = `${rect.top - tooltip.offsetHeight - 8}px`;
    tooltip.style.left = `${rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2)}px`;
    
    tooltipTimeout = setTimeout(() => {
      tooltip.style.opacity = '1';
      tooltip.style.transition = 'opacity 0.2s ease';
    }, 10);
  }

  function hideTooltip() {
    clearTimeout(tooltipTimeout);
    const tooltip = document.querySelector('.swatch-tooltip');
    if (tooltip) {
      tooltip.remove();
    }
  }

  /**
   * Sticky Elements
   */
  function initStickyElements() {
    const productInfo = document.querySelector('.product-custom-info');
    if (!productInfo || window.innerWidth <= 990) return;

    let lastScrollTop = 0;
    const header = document.querySelector('.shopify-section-header');
    const headerHeight = header ? header.offsetHeight : 100;

    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';
      
      // Adjust sticky top based on scroll direction
      if (scrollDirection === 'down' && scrollTop > headerHeight) {
        productInfo.style.top = '20px';
      } else {
        productInfo.style.top = `${headerHeight + 20}px`;
      }
      
      lastScrollTop = scrollTop;
    });
  }

  /**
   * Lazy Loading for Images
   */
  function initLazyLoading() {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
              img.removeAttribute('data-srcset');
            }
            img.classList.add('loaded');
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: '50px'
      });

      document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    } else {
      // Fallback for browsers without IntersectionObserver
      document.querySelectorAll('img[data-src]').forEach(img => {
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      });
    }
  }

  /**
   * Handle Video Playback
   */
  document.addEventListener('click', function(e) {
    if (e.target.closest('.media-item[data-media-type="video"]')) {
      const video = e.target.closest('.media-item').querySelector('video');
      if (video) {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      }
    }
  });

  /**
   * Smooth Scroll to Tabs
   */
  const tabButtons = document.querySelectorAll('.product-tab-button');
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const tabsSection = document.querySelector('.product-tabs-section');
      if (tabsSection && window.innerWidth <= 768) {
        setTimeout(() => {
          tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    });
  });

  /**
   * Escape key to close modals
   */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const openModal = document.querySelector('.product-modal[style*="display: block"]');
      if (openModal) {
        openModal.style.display = 'none';
        document.body.style.overflow = '';
      }

      const sizeGuideModal = document.getElementById('size-guide-modal');
      if (sizeGuideModal && sizeGuideModal.style.display === 'block') {
        sizeGuideModal.style.display = 'none';
      }
    }
  });

  /**
   * Copy Product URL
   */
  window.copyProductURL = function() {
    const url = window.location.href;
    
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(() => {
        showNotification('Product URL copied to clipboard!');
      }).catch(err => {
        console.error('Failed to copy:', err);
      });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = url;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        showNotification('Product URL copied to clipboard!');
      } catch (err) {
        console.error('Failed to copy:', err);
      }
      
      document.body.removeChild(textArea);
    }
  };

  /**
   * Show Notification
   */
  function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `product-notification ${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: ${type === 'success' ? '#2d5016' : '#dc2626'};
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 10000;
      font-size: 14px;
      font-weight: 600;
      animation: slideInUp 0.3s ease;
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.animation = 'slideOutDown 0.3s ease';
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }

  // Add animations to document
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideInUp {
      from {
        transform: translateY(100%);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
    
    @keyframes slideOutDown {
      from {
        transform: translateY(0);
        opacity: 1;
      }
      to {
        transform: translateY(100%);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

  /**
   * Handle window resize
   */
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Re-initialize sticky elements on resize
      initStickyElements();
    }, 250);
  });

  /**
   * Expose global functions
   */
  window.ProductCustom = {
    showNotification: showNotification,
    copyProductURL: copyProductURL
  };

})();